import Api from '@/services/Index';

const getStudentStatus = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/u-pass/student/status');
};

const purchaseStudentUPass = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/u-pass/student/purchase');
};

const getPeriods = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/u-pass/periods', config);
};

const createPeriod = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/u-pass/periods', data);
};

const getPeriod = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/u-pass/periods/${id}`);
};

const updatePeriod = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/u-pass/periods/${id}`, data);
};

const getPurchases = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/u-pass/purchases', config);
};

const excelExport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/u-pass/purchases/excel-export',{...formData,responseType: 'arraybuffer'});
}
export default {
    getStudentStatus,
    purchaseStudentUPass,
    getPeriods,
    createPeriod,
    getPeriod,
    updatePeriod,
    getPurchases,
    excelExport

};
